import React, { useEffect, useRef, useState } from 'react';
import LoadingIcon from '../../images/Loading_icon.gif';

export const ImagenesGlobal = ({
    url = null,
    type = 'picture',
    alt = "",
    className = "",
    style = {},
    onClick = (() => { }),
    loadImageS =(()=>{})
}) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const imgRef = useRef();

    // Observer: activa la carga al hacer visible la imagen
    useEffect(() => {
        if (url == null) {
            async function forceResponse() {
                const response = await loadImageS(url, type);
                setImageSrc(response);
            }
            forceResponse();
            return;
        }

        if (typeof url == 'object') return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            {
                threshold: 0.1,
            }
        );

        if (imgRef.current) observer.observe(imgRef.current);

        return () => {
            if (imgRef.current) observer.unobserve(imgRef.current);
        };
    }, []); // Importante: solo se debe ejecutar una sola vez (gatos)

    // Carga la imagen cuando se vuelve visible
    useEffect(() => {
        if (typeof url == 'object' || url == null) return;

        if (isVisible && imageSrc == null) {
            const functionLoader = async () => {
                try {
                    const response = await loadImageS(url, type);
                    if (response) setImageSrc(response);
                    else console.error("Error:", response);
                } catch (error) {
                    console.error("Error loading image:", error);
                }
            };
            functionLoader();
        }
    }, [isVisible, imageSrc, loadImageS, url, type]);

    const srcSelected = imageSrc && url == null ? (imageSrc) : (typeof url == 'object' ? url?.temporalImg : (isVisible && imageSrc ? imageSrc : LoadingIcon));

    return (
        <img
            ref={imgRef}
            src={srcSelected}
            onError={() => console.error("No fue posible cargar la imagen:", url)}
            style={style}
            className={className}
            alt={alt}
            onClick={onClick}
            key={typeof url != 'object' ? url : null}
        />
    );
};
